interface InviteHeroReferralProps {
  headline: string
  subtitle: string
  inviterName?: string
}

export const InviteHeroReferral = ({ headline, subtitle, inviterName }: InviteHeroReferralProps) => {
  const initial = inviterName?.trim().charAt(0).toUpperCase()

  return (
    <header className="text-center space-y-3">
      {initial && (
        <div className="flex justify-center">
          <div
            className="h-11 w-11 rounded-full bg-accent/10 ring-1 ring-accent/30 flex items-center justify-center"
            aria-hidden
          >
            <span className="text-base font-semibold text-accent select-none" translate="no">
              {initial}
            </span>
          </div>
        </div>
      )}
      <h1 className="text-2xl font-semibold leading-tight">{headline}</h1>
      <p className="text-sm text-muted-foreground">{subtitle}</p>
    </header>
  )
}
